import React from 'react';
import AdminLayout from './admin/AdminLayout';
import AdminChatPanel from '../components/chatbot/admin/AdminChatPanel';

const AdminChat = () => {
  return <AdminChatPanel />;
};

export default AdminChat;
